// extracted by mini-css-extract-plugin
export default {"container":"FD-z"};